import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    // Use sanitize() with SecurityContext.HTML to allow safe HTML tags
    // This will strip dangerous content while preserving safe HTML like <a>, <b>, <i>, etc.
    return this.sanitizer.sanitize(SecurityContext.HTML, value) || '';
  }
}
